import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

export default function AnonymousRoute(props) {
  const user = useSelector(state => state.user);
  return user?.token ? <Redirect to={props.redirect} /> : <Route {...props} />;
}
